export default "__VITE_ASSET__Bw76I7wl__"